import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "isCellHidden",
})
export class IsCellHiddenPipe implements PipeTransform {
  transform(colspan?: number): boolean {
    return colspan !== undefined && !colspan;
  }
}
